module.exports = __webpack_public_path__ + "img/huajiadian2.4c23923d.png";